/**
 * Created on 02/9/19.
 */
export default {
    name: 'Offering Summary',
    headerRow: ['Offering Summary', null],
    rows: {
        'price': {
            name: 'Price',
            editable: false,
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = precomputedValues.pricingValue;
                const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                return {internalValue: value, displayValue: displayValue}
            }
        },
        'cap-rate': {
            name: 'Cap Rate',
            editable: false,
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = tabs['pricing-tab'].tables['value'].rows['cap-rate'].valueCells[2].value;
                const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2})}%`;
                return {internalValue: value, displayValue: displayValue}
            }
        },
        'net-operating-income': {
            name: 'Net Operating Income',
            editable: false,
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = parseInt(precomputedValues.netOperatingIncome);
                const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue}
            }
        },
        'price-psf': {
            name: 'Price PSF',
            editable: false,
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = tabs['pricing-tab'].tables['value'].rows['value'].valueCells[3].getComputedValue(tabs, precomputedValues).internalValue;
                const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue}
            }
        },
        'occupancy': {
            name: 'Occupancy',
            editable: false,
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = tabs['current-rr-tab'].tables['sumed-detailed-information'].rows['first-row'].valueCells[0].getComputedValue(tabs, 'first-row', precomputedValues).internalValue;
                const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2})}%`;
                return {internalValue: value, displayValue: displayValue}
            }
        },
        'year-built': {
            name: 'Year Built',
            editable: false,
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = tabs['property-information-tab'].tables['other-information'].rows['year-built'].value;
                const displayValue = !value || isNaN(value) ? '-' : value;
                return {internalValue: value, displayValue: displayValue}
            }
        },
        'gross-leasable-area': {
            name: 'Gross Leasable Area',
            editable: false,
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = precomputedValues.totalSpace;
                const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString()} SF`;
                return {internalValue: value, displayValue: displayValue}
            }
        },
        'lot-size': {
            name: 'Lot Size',
            editable: false,
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = tabs['property-information-tab'].tables['other-information'].rows['lot-size'].value;
                const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString()} Acres`;
                return {internalValue: value, displayValue: displayValue}
            }
        },
    }
};